import React, { useState, useEffect } from 'react';
import classNames from 'classnames/bind';
import { Button } from '@thd-olt-component-react/button';
import { func, string } from 'prop-types';
import styles from './custom-catalog-button.module.scss';

let cx = classNames.bind(styles);

const CustomCatalogButton = ({ onCpoClick, value }) => {
  return (
    <div className={cx('custom-catalog-button')}>
      <Button value={value} onClickCapture={onCpoClick}>
        <span>Search All Products</span>
      </Button>
    </div>
  );
};

CustomCatalogButton.displayName = 'CustomCatalogButton';

CustomCatalogButton.propTypes = {
  onCpoClick: func,
  value: string,
};

CustomCatalogButton.defaultProps = {
  onCpoClick: () => {},
  value: 'false',
};

export { CustomCatalogButton };
